import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";
import { generate_random_color } from "#root/shared/utility_functions/color_functions.js";

export const createRow = async (timelineObject) => {
  const newLabel = timelineObject.label || "New Row";
  const newDescription = timelineObject.description || "";
  const newPrimaryColor =
    timelineObject.primaryColor || generate_random_color("color");
  const newSecondaryColor =
    timelineObject.secondaryColor || generate_random_color("shade");
  const newPublishStatus = timelineObject.publishStatus || "published";
  const newSourceOrigin = timelineObject.sourceOrigin || "website";
  const newChartType = timelineObject.chartType || "row";
  const chartID = timelineObject.chartID || null;

  const newRowObject = {
    payload: {
      timeline: {
        label: newLabel,
        description: newDescription,
        primaryColor: newPrimaryColor,
        secondaryColor: newSecondaryColor,
        publishStatus: newPublishStatus,
        sourceOrigin: newSourceOrigin,
      },
      metadata: {
        chartType: newChartType,
        chartID: chartID,
      },
    },
  };
  const serverResponse = await sendRequestToServer(
    newRowObject,
    "/server/database_operations/rows/createRow",
  );
  return serverResponse;
};
